













import { Component, Vue } from 'vue-property-decorator'
import cr from "@/CompositionRoot";
import _ from "lodash";
import { ImageInfo, ImageInfos } from "frontend-common";
import InlineImageUpload from "@/components/dashboard/common/InlineImageUpload.vue";
import ImagesGrid from "@/components/dashboard/ImagesGrid.vue";

@Component({
    components: { InlineImageUpload, ImagesGrid }
}) export default class extends Vue {

    getImages(): ImageInfos {
        return cr.organizationModule.images
    }

    isEmpty(): boolean {
        return _.isEmpty(this.getImages())
    }

    onImageClicked(imageInfo: ImageInfo) {
        this.$emit("onImageChosen", imageInfo)
    }
}
